
type RecipientBankAccountProps = {
  children: string;
};

const formatIban = ( value: any ) => {
  if ( typeof value === 'string' ) {
    return value.replace( /\s+/g, '' ).replace( /(.{4})/g, '$1 ' ).trim();
  }

  return value;
}

export const RecipientBankAccount = ( { children }: RecipientBankAccountProps ) => {

  return (
    <div className={ 'text-[#ABB0C799] text-xs pl-7' }>
      {formatIban( children )}
    </div>
  )
}
RecipientBankAccount.displayName = 'RecipientBankAccount';
